import axios from 'axios'
import { Message } from 'element-ui'
import { handleUnauthorized, getLoginStorage } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://www.esks.com.cn/multimodal/api/',
  timeout: 3000000
})

function isUnauthorizedPayload(data) {
  if (!data || typeof data !== 'object') return false
  const code = data.code != null ? data.code : data.state
  return Number(code) === 401
}

function extractUnauthorizedMessage(response) {
  const data = response && response.data
  if (data && typeof data === 'object' && data.message) {
    return data.message
  }
  return '登录已过期，请重新登录'
}

service.interceptors.request.use(
  config => {
    const userData = getLoginStorage()
    if (userData && userData.token) {
      config.headers['Authorization'] = `Bearer ${userData.token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    if (response.status === 401) {
      handleUnauthorized(extractUnauthorizedMessage(response))
      return Promise.reject(response)
    }

    if (response.config.responseType === 'blob' || response.data instanceof Blob) {
      return response
    }

    const res = response.data
    if (isUnauthorizedPayload(res)) {
      handleUnauthorized(res.message)
      return Promise.reject(res)
    }

    if (res.code === 10200 || res.state === 10200 || (!res.code && !res.state)) {
      return res
    }

    Message({
      message: res.message || '请求失败',
      type: 'error',
      duration: 2 * 1000,
      offset: 200
    })
    return Promise.reject(res)
  },
  error => {
    const response = error.response
    if (response && (response.status === 401 || isUnauthorizedPayload(response.data))) {
      handleUnauthorized(extractUnauthorizedMessage(response))
      return Promise.reject(error)
    }

    Message({
      message: error.message || '网络异常',
      type: 'error',
      duration: 2 * 1000,
      offset: 200
    })
    return Promise.reject(error)
  }
)

export default service
